import { type BundleDTO, type BundleFullDTO, type OldProductDTO, type Option } from 'ecosystem'
import storefrontApi from '../storefront-api'

/**  VARIANT GROUP PRODUCTS DETAILS FETCH */
export async function variantsFactory(
  variantGroupId: string | null,
  customerId?: string | null
): Promise<OldProductDTO[] | null> {
  if (!variantGroupId) {
    return null
  }
  return storefrontApi.products.variantsByGroupId(variantGroupId, customerId ?? undefined)
}

/**  VARIANT GROUPS PRODUCTS DETAILS FETCH */
export async function variantsByIdsFactory(
  variantGroupIds?: (string | null)[],
  customerId?: string | null
): Promise<Option<Record<string, { data?: OldProductDTO[] | null; error?: string }>>> {
  const filteredIds = variantGroupIds?.filter((id) => typeof id === 'string')

  if (!filteredIds?.length) {
    return null
  }

  const variantsByIds: Record<string, { data?: OldProductDTO[] | null; error?: string }> = {}

  await Promise.all(
    filteredIds.map((variantGroupId) =>
      storefrontApi.products
        .variantsByGroupId(variantGroupId, customerId ?? undefined)
        .then((res) => {
          variantsByIds[variantGroupId] = { data: res }
        })
        .catch((err: unknown) => {
          console.error(err)
          if (err instanceof Error) {
            variantsByIds[variantGroupId] = { error: err.message }
          } else {
            variantsByIds[variantGroupId] = { error: 'Unknown error' }
          }
        })
    )
  )

  return variantsByIds
}

/**  BUNDLE PRODUCTS DETAILS FETCH */
export async function bundleProductsFactory(
  bundles: BundleDTO[] | null,
  customerId?: string | null
): Promise<BundleFullDTO[] | null> {
  if (!bundles?.length) {
    return null
  }

  const bundleProductsResponse: BundleFullDTO[] = []

  for (const { productId, quantity } of bundles) {
    const product = await storefrontApi.products.productById(productId, customerId ?? undefined)

    if (product) {
      bundleProductsResponse.push({ product, quantity })
    }
  }

  return bundleProductsResponse
}

export { getProductImages } from 'shared-utils/utils/products'
